import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const CrudModalList = ({
    title,
    data = [],
    fields = [],
    columns = [],
    initialState = {},
    onSave,
    onDelete
}) => {
    const [modal, setModal] = useState(false);
    const [form, setForm] = useState(initialState);
    const [idEditando, setIdEditando] = useState(null);

    const openNew = () => {
        setForm(initialState);
        setIdEditando(null);
        setModal(true);
    };

    const openEdit = (item) => {
        setForm(item);
        setIdEditando(item.id);
        setModal(true);
    };

    const close = () => {
        setModal(false);
        setForm(initialState);
        setIdEditando(null);
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSave = () => {
        const payload = {
            ...form
        };
        if (idEditando) {
            payload.id = idEditando;
        }
        onSave && onSave(payload);
        close();
    };

    const handleDelete = (id) => {
        onDelete && onDelete(id);
    };

    return (
        <>
            <Modal isOpen={modal} toggle={close} size="lg">
                <ModalHeader toggle={close}>
                    {idEditando ? `Editar ${title}` : `Novo ${title}`}
                </ModalHeader>

                <ModalBody>
                    <form className="hdv-form-default">
                        <div className="row">
                            {fields.map((field) => (
                                <div className={field.col || "col-md-12"} key={field.id}>
                                    <label>{field.label}</label>
                                    <input
                                        type="text"
                                        id={field.id}
                                        value={form[field.id] || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            ))}
                        </div>
                    </form>
                </ModalBody>

                <ModalFooter>
                    {idEditando && (
                        <button
                            className="hdv-btn-forms hdv-btn-orange"
                            onClick={() => {
                                setForm(initialState);
                                setIdEditando(null);
                            }}
                        >
                            Cancelar edição
                        </button>
                    )}

                    <button
                        className="hdv-btn-forms hdv-btn-blue"
                        onClick={handleSave}
                    >
                        {idEditando ? "Atualizar" : "Adicionar"}
                    </button>

                    <button
                        className="hdv-btn-forms hdv-btn-default"
                        onClick={close}
                    >
                        Fechar
                    </button>
                </ModalFooter>
            </Modal>

            <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="hdv-subtable-title m-0">{title}s</h6>
                <button
                    className="hdv-btn-forms hdv-btn-green m-0"
                    onClick={openNew}
                >
                    Novo {title}
                </button>
            </div>

            <table className="hdv-subtable afira-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <td key={col.key}>{col.label}</td>
                        ))}
                        <td style={{ textAlign: "center" }}>Ações</td>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.id}>
                            {columns.map((col) => (
                                <td key={col.key}>{item[col.key]}</td>
                            ))}
                            <td className="hdv-subtable-action-td">
                                <button
                                    className="hdv-btn-forms hdv-btn-yellow"
                                    onClick={() => openEdit(item)}
                                >
                                    Editar
                                </button>

                                <button
                                    className="hdv-btn-forms hdv-btn-red"
                                    onClick={() => handleDelete(item.id)}
                                >
                                    Deletar
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default CrudModalList;